import React, { useState, useEffect } from "react";
import Modal from "./Modal";
import LoadingLogo from "./LoadingLogo";
import "./DownloadFilenameModal.css";

interface DownloadFilenameModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (filename: string, format: 'csv' | 'xl') => void;
    defaultFilename: string;
    isLoading?: boolean;
}

const DownloadFilenameModal: React.FC<DownloadFilenameModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    defaultFilename,
    isLoading = false
}) => {
    const [filename, setFilename] = useState("");

    useEffect(() => {
        setFilename("");
    }, [defaultFilename]);

    const handleConfirm = (format: 'csv' | 'xl') => {
        onConfirm(filename || defaultFilename, format);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleConfirm('csv'); // Default to CSV on Enter
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            title="Download Data"
            onCancel={onClose}
            hideButtons={true}
        >
            <div className="filename-input-container">
                {isLoading ? (
                    <div className="loading-container">
                        <LoadingLogo text="Preparing data for download..." />
                    </div>
                ) : (
                    <input
                        type="text"
                        value={filename}
                        onChange={(e) => setFilename(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder={defaultFilename}
                        className="filename-input"
                    />
                )}
            </div>
            <div className="download-modal-actions">
                <button
                    className="button-primary download-btn"
                    onClick={() => handleConfirm('csv')}
                    disabled={isLoading}
                >
                    Download CSV
                </button>
                <button
                    className="button-primary download-btn"
                    onClick={() => handleConfirm('xl')}
                    disabled={isLoading}
                >
                    Download XL
                </button>
                <button
                    className="button-secondary download-btn"
                    onClick={onClose}
                    disabled={isLoading}
                >
                    Cancel
                </button>
            </div>
        </Modal>
    );
};

export default DownloadFilenameModal; 